<template>
  <div class="business-header">
    <div class="background" :style="`background-image:url('${content.img}')`">
      <div class="content">
        <customTitle :content="content.title[0]" class="business-title"></customTitle>
        <vue-markdown v-html="content.text" class="business-text"></vue-markdown>
        <scroll-indicator class="scroll"></scroll-indicator>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.business-header {
  width: 100%;
  height: 100vh;
  .background {
    background-size: cover;
    background-position: center;
    height: 100%;
    width: 100%;
    .content {
      height: 100%;
      color: white;
      padding-top: 25%;
      text-align: left;
      .title {
        color: white;
      }
      .business-text {
        max-width: 80%;
        padding-left: 4%;
        font-size: 20px;
        line-height: 2.5;
      }
      .scroll {
        bottom: 10%;
      }
    }
  }
}
@media screen and (max-width: $tablet) {
  .business-header {
    .background {
      .content {
        .business-text {
          font-size: 16px;
          margin: auto;
        }
      }
    }
  }
}
</style>
